__turbopack_context__.v({
  "body": "InscriptionCardSmall-module__bsL-cq__body",
  "content": "InscriptionCardSmall-module__bsL-cq__content",
  "number": "InscriptionCardSmall-module__bsL-cq__number",
  "punks": "InscriptionCardSmall-module__bsL-cq__punks",
  "rankDesktop": "InscriptionCardSmall-module__bsL-cq__rankDesktop",
  "rankMobile": "InscriptionCardSmall-module__bsL-cq__rankMobile",
  "root": "InscriptionCardSmall-module__bsL-cq__root",
  "row": "InscriptionCardSmall-module__bsL-cq__row",
  "subtitle": "InscriptionCardSmall-module__bsL-cq__subtitle",
  "title": "InscriptionCardSmall-module__bsL-cq__title",
});
